module.exports = __webpack_public_path__ + "static/media/DFFT_replit_icon.f9296647.png";